<nav id="navbar" class="fixed w-full top-0 z-50 bg-[#020042] text-white" aria-label="Main Navigation">
  <div class="max-w-6xl mx-auto px-4">
    <div class="flex justify-between items-center">
      <!-- Logo -->
      <div>
        <a href="/" class="flex items-center py-5 px-2" aria-label="Home">
          <img [src]="logoImages[1].src" [attr.srcset]="logoSrcSet"
            sizes="(max-width: 640px) 150px, (max-width: 1024px) 200px, (max-width: 1280px) 250px, 300px" alt="Logo"
            width="300" height="80" loading="eager" decoding="async"
            class="h-8 w-auto sm:h-10 md:h-12 lg:h-14 xl:h-16 2xl:h-20 xl:w-auto mr-4 max-w-xs object-contain" />
        </a>
      </div>

      <!-- Primary Nav -->
      <div class="hidden md:flex flex-1 justify-center space-x-4 mt-2 md:mt-4 lg:mt-6 xl:mt-8 2xl:mt-10">
        <a href="/" role="link" tabindex="0" aria-label="Ir a la página de inicio"
          class="nav-link py-8 px-3 text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl"> {{
          'navbar.home' | translate }}</a>
        <a href="/about" role="link" tabindex="0" aria-label="Ir a la página Nosotros"
          class="nav-link py-8 px-3 text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl"
          aria-label="About Us">{{ 'navbar.about' | translate }}</a>
        <a href="/arqit-services" role="link" tabindex="0" aria-label="Ir a la página Servicios"
          class="nav-link py-8 px-3 text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl"
          aria-label="Services">{{ 'navbar.services' | translate }}</a>
        <a href="/contact" role="link" tabindex="0" aria-label="Ir a la página de Contacto"
          class="nav-link py-8 px-3 text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl"
          aria-label="Contact">{{ 'navbar.contact' | translate }}</a>
        <!-- Language selector -->
        <div class="hidden lg:flex ml-4">
          <app-language-selector></app-language-selector>
        </div>

      </div>

      <!-- Secondary Nav -->
      <div class="hidden md:flex items-center space-x-1">
        <a href="https://www.linkedin.com/company/arqit-cl/?originalSubdomain=cl" rel="noopener noreferrer"
          target="_blank" role="link" tabindex="0"
          aria-label="Ir al perfil de LinkedIn de arq-it (se abre en nueva pestaña)"
          class="nav-icon mt-2 md:mt-4 lg:mt-6 xl:mt-8 2xl:mt-8 px-3" aria-label="LinkedIn">
          <i class="fab fa-linkedin fa-1x"></i>
        </a>
      </div>

      <!-- Mobile button -->
      <div class="md:hidden flex items-center">
        <button class="mobile-menu-button" aria-expanded="false" aria-controls="mobile-menu"
          aria-label="Toggle navigation menu">
          <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile Menu -->
  <div id="mobile-menu" class="mobile-menu md:hidden hidden bg-[#020042]" aria-label="Mobile Navigation">
    <a href="/"
      class="nav-link-mobile block py-2 px-4 text-sm text-[#F2F4FE] hover:bg-white/10 focus:outline-none rounded transition duration-200">
      {{'navbar.home' | translate }}
    </a>
    <a href="/about" role="link" tabindex="0" aria-label="Ir a la página Nosotros"
      class="nav-link-mobile block py-2 px-4 text-sm text-[#F2F4FE] hover:bg-white/10 focus:outline-none rounded transition duration-200">
      {{ 'navbar.about' | translate }}
    </a>
    <a href="/arqit-services" role="link" tabindex="0" aria-label="Ir a la página Servicios"
      class="nav-link-mobile block py-2 px-4 text-sm text-[#F2F4FE] hover:bg-white/10 focus:outline-none rounded transition duration-200">
      {{ 'navbar.services' | translate }}
    </a>
    <a href="/contact" role="link" tabindex="0" aria-label="Ir a la página de Contacto"
      class="nav-link-mobile block py-2 px-4 text-sm text-[#F2F4FE] hover:bg-white/10 focus:outline-none rounded transition duration-200">
      {{ 'navbar.contact' | translate }}
    </a>
    <a href="https://www.linkedin.com/company/arqit-cl/?originalSubdomain=cl" rel="noopener noreferrer" target="_blank"
      role="link" tabindex="0" aria-label="Ir al perfil de LinkedIn de arq-it (se abre en nueva pestaña)"
      class="nav-link-mobile block py-2 px-4 text-sm text-[#F2F4FE] hover:bg-white/10 focus:outline-none rounded transition duration-200">
      LinkedIn
    </a>
    <!-- Language Selector in Mobile -->
    <div class="mt-1 mb-2">
      <app-language-selector></app-language-selector>
    </div>

  </div>
</nav>